<template>
  <div style="display: flex; justify-content: space-around; align-items: center;">
    <div class="image-box" v-for="(item, index) in urls" :key="index">
      <img :src="item.url" :title="item.text" @click="downloadImage(item.url)" style="cursor: pointer;" alt="">
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      urls: [
        { id: 1, text: '点击图片下载2023年度江苏省行业领域十大科技进展提名.png', url: require('../assets/imgs/announcement/publicity1.png') },
        { id: 2, text: '点击图片下载江苏海宏科技公司市场化选聘市场营销副总拟聘人员公示.jpg', url: require('../assets/imgs/announcement/publicity2.jpg') },
        { id: 3, text: '点击图片下载江苏海宏科技公司市场化选聘市场营销副总拟聘人员公示.jpg', url: require('../assets/imgs/announcement/publicity3.jpg') }
      ]
    }
  },
  methods: {
    downloadImage(url) {
      // 创建一个临时的 <a> 标签
      const link = document.createElement('a')
      link.href = url // 设置为当前图片的 URL
      link.download = url.split('/').pop() // 提取图片的文件名作为下载名称
      link.click() // 触发下载
    }
  }
}
</script>

<style scoped>
.image-box{
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 30vw;
  height: 80vh;
}

.img{
  width: 100%;
  height: 100%;
}
</style>
